var map = {
	"./Google_Sans/GoogleSans-Italic-VariableFont_GRAD,opsz,wght.ttf": 3419,
	"./Google_Sans/GoogleSans-VariableFont_GRAD,opsz,wght.ttf": 392,
	"./Google_Sans/static/GoogleSans-Bold.ttf": 6698,
	"./Google_Sans/static/GoogleSans-BoldItalic.ttf": 5142,
	"./Google_Sans/static/GoogleSans-Italic.ttf": 5187,
	"./Google_Sans/static/GoogleSans-Medium.ttf": 6074,
	"./Google_Sans/static/GoogleSans-MediumItalic.ttf": 1398,
	"./Google_Sans/static/GoogleSans-Regular.ttf": 1561,
	"./Google_Sans/static/GoogleSans-SemiBold.ttf": 4428,
	"./Google_Sans/static/GoogleSans-SemiBoldItalic.ttf": 6140,
	"./Google_Sans/static/GoogleSans_17pt-Bold.ttf": 5451,
	"./Google_Sans/static/GoogleSans_17pt-BoldItalic.ttf": 3443,
	"./Google_Sans/static/GoogleSans_17pt-Italic.ttf": 3738,
	"./Google_Sans/static/GoogleSans_17pt-Medium.ttf": 543,
	"./Google_Sans/static/GoogleSans_17pt-MediumItalic.ttf": 3511,
	"./Google_Sans/static/GoogleSans_17pt-Regular.ttf": 738,
	"./Google_Sans/static/GoogleSans_17pt-SemiBold.ttf": 9297,
	"./Google_Sans/static/GoogleSans_17pt-SemiBoldItalic.ttf": 4733,
	"./Inter/Inter_18pt-Black.ttf": 4212,
	"./Inter/Inter_18pt-BlackItalic.ttf": 4116,
	"./Inter/Inter_18pt-Bold.ttf": 522,
	"./Inter/Inter_18pt-BoldItalic.ttf": 1126,
	"./Inter/Inter_18pt-ExtraBold.ttf": 4166,
	"./Inter/Inter_18pt-ExtraBoldItalic.ttf": 8738,
	"./Inter/Inter_18pt-ExtraLight.ttf": 861,
	"./Inter/Inter_18pt-ExtraLightItalic.ttf": 6265,
	"./Inter/Inter_18pt-Italic.ttf": 3651,
	"./Inter/Inter_18pt-Light.ttf": 8441,
	"./Inter/Inter_18pt-LightItalic.ttf": 8485,
	"./Inter/Inter_18pt-Medium.ttf": 4538,
	"./Inter/Inter_18pt-MediumItalic.ttf": 4854,
	"./Inter/Inter_18pt-Regular.ttf": 7017,
	"./Inter/Inter_18pt-SemiBold.ttf": 1980,
	"./Inter/Inter_18pt-SemiBoldItalic.ttf": 9804,
	"./Inter/Inter_18pt-Thin.ttf": 8022,
	"./Inter/Inter_18pt-ThinItalic.ttf": 3314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8056;